export default __webpack_public_path__ + "static/media/create-account-office.080280cb.jpeg";